module.exports = __webpack_public_path__ + "img/lachskaviarsushiflambiertfrontal.9a77b0e8.png";